var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.wrapper,{tag:"component",staticClass:"box",class:[
        _vm.shadowClass,
        _vm.noPadding && 'box--no-padding'
    ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }